import { IGenre } from '../types/interfaces/genre';
import { store } from '../store/store';

class Genre {
  id: string;
  name: string;
  category: string;
  title: string;

  constructor(requestGenre: IGenre) {
    this.id = requestGenre.id;
    this.title = requestGenre.title;
    this.category = requestGenre.category;
    this.name = requestGenre.name;
  }

  static getGenreById(id: string) {
    const { genres } = store.getState();
    const found = genres.data?.find((genre) => {
      return genre.id === id;
    });
    return found;
  }

  static getSortingCriteria(genre: Genre | undefined, customCategory?: string) {
    const { categories } = store.getState();
    const found = categories.data?.find((category) => {
      if (customCategory) {
        const cat = category.type === customCategory;
        if (cat) return cat;
      }
      return category.id === genre?.category;
    });
    return [found?.orderField, found?.orderSort];
  }
}

export default Genre;
